import Vue from 'vue';
import Router from 'vue-router';
import auth0 from '@/services/auth0';

Vue.use(Router);

const requireAuth = async (to, from, next) => {
  const { isLoggedIn, state = {} } = await auth0.loginStatus();
  if (isLoggedIn) return next(state.redirect);

  const redirectUri = `${window.location.protocol}//${window.location.host}`;
  return auth0.authorize(redirectUri, { redirect: to.fullPath });
};

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'root',
      component: () => import('./components/views/Main/Index.vue'),
    },
    {
      path: '/list',
      name: 'market-list',
      component: () => import('./components/views/MarketList/Index.vue'),
    },
    {
      path: '/setup',
      name: 'setup',
      component: () => import('./components/views/Setup/Index.vue'),
    },
    {
      path: '/setup/market/new',
      name: 'create-custom-market',
      component: () => import('./components/views/CustomMarket/Index.vue'),
    },
    {
      path: '/setup/market/:marketId',
      name: 'update-custom-market',
      component: () => import('./components/views/CustomMarket/Index.vue'),
      props: true,
    },
  ],
});

router.beforeEach(requireAuth);

export default router;
